import { createApiSlice } from "@common";
import { CRUD_PERSON_TITLE } from "@routes";

const apiConfig = [
  {
    name: "addPersonTitle",
    method: "post",
    url: CRUD_PERSON_TITLE,
    stateKey: "message",
  },
  {
    name: "getPersonTitle",
    method: "get",
    url: CRUD_PERSON_TITLE,
    stateKey: "data",
  },
  {
    name: "updatePersonTitle",
    method: "put",
    url: CRUD_PERSON_TITLE,
    stateKey: "message",
  },
  {
    name: "deletePersonTitle",
    method: "delete",
    url: CRUD_PERSON_TITLE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
"personTitle",
 apiConfig, 
 customReducers);
const personTitleSlice = slice;

export default personTitleSlice.reducer;

export const {
  addPersonTitle,
  getPersonTitle,
  updatePersonTitle,
  deletePersonTitle,
} = thunks;

export const { rowSelect } = actions;
